import React from "react";
import * as PropTypes from "prop-types";
import DescriptionRow from "../Shared/DescriptionPanel/DescriptionRow";
import DescriptionPanel from "../Shared/DescriptionPanel/DescriptionPanel";

const RigakuSulphurDescriptionPanel = (props) => (
  <DescriptionPanel>
    <DescriptionRow
      title="Instrument ID"
      value={props.instrumentInfo.name}
      icon="hashtag"
    />

    <DescriptionRow
      title="Type"
      value="Rigaku Sulphur"
      icon="cube"
    />

    <DescriptionRow
      title="Location"
      icon="cube"
      value={props.instrumentInfo.location}
    />

    <DescriptionRow
      title="Serial Number"
      value={props.instrumentInfo.current_serial_number}
      icon="id-card"
    />
  </DescriptionPanel>
);

RigakuSulphurDescriptionPanel.propTypes = {
  instrumentInfo: PropTypes.object.isRequired,
};

export default RigakuSulphurDescriptionPanel;
